module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7XJujp/tc-custom/9783965370272.jpg?1702957710332",
      "alt": "This image is the cover for the book Watch the Sky, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Watch the Sky, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Geest gun — the Gunderland Battle trophy on the wall — attracts plotters and generates a plot. Like Rudyard Kipling's bejeweled elephant-goad in \"The King's Ankus\", the Geest gun stirs ambition in people. More than in the Kipling though, these seem competent, thoughtfully dangerous men.(Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James H. Schmitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Henry Schmitz (October 15, 1911 – April 18, 1981) was an American science fiction writer born in Hamburg, Germany of American parents. Schmitz wrote mostly short stories, which sold chiefly to Galaxy Science Fiction and Astounding Science-Fiction (which later became Analog Science Fiction and Fact). Gale Biography in Context called him \"a craftsman-like writer who was a steady contributor to science fiction magazines for over 20 years.\" (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0